<template lang="pug">

  div
    MHeader( page-title="Scheduling" )

    div( class="wrapper-content" )

      div( class="ibox w-25 d-none" )
        div( class="ibox-content" )
          h3 Scheduled Batches Overview

          div( class="row" )
            div( class="col-sm-8" )
              strong Estimated monthly usage:
            div( class="col-sm-4" ) -1

          div( class="row" )
            div( class="col-sm-8" )
              strong Your usual monthly link credits:
            div( class="col-sm-4" ) -1

          div( class="row" )
            div( class="col-sm-8" )
              strong To end of month:
            div( class="col-sm-4" ) -1

          div( class="row" )
            div( class="col-sm-8" )
              strong Requirement to process scheduled batches:
            div( class="col-sm-4" ) -1

      div( class="ibox" )
        div( class="ibox-content" )
          h3 Create Schedule Template From Existing Batch

          p Create a new Schedule Template from a recently completed batch:

          select( class="form-control" disabled="disabled" v-if="$apollo.queries.lastTenBatches.loading" )
            option Loading...

          select( class="form-control batch-list" v-model="recentBatchId" v-else )
            option( v-bind:value="null" ) Please select
            option( v-for="batch in lastTenBatches" v-bind:value="batch.id" )
              | [{{ dateFormat(batch.startedAt, 'dd/mm/yy HH:MM') }}] {{ batch.name }} {{ batch.description }}

          p( class="mt-3" )
            button( class="btn btn-primary" v-on:click="onCreateScheduledBatch" v-bind:disabled="creatingScheduledBatch || ! recentBatchId" )
              MLoadingSpinner( class="mr-2" v-if="creatingScheduledBatch" )
              | Create Schedule Template as a clone of this batch

          p( class="mt-3 mb-0" ) You can immediately add/delete some link entries to/from this Template once it's been created.

      div( class="ibox" )
        div( class="ibox-content" )
          h3 Create Schedule Template From CSV Upload

          p Create a new Schedule Template from a standard CSV upload:

          p
            label( for="newTemplateCopyBatchId" )
              | Copy settings from existing template:
              br
              em Note: Only batches on the current page are displayed in the drop-down. Use the filter and next/prev page buttons to find the batch you want to copy from.
              br
              small( class="font-italic" ) Name, description, queue letter and schedule will be copied to the new template. No links will be kept; they will be defined by the new CSV upload.

            select( class="form-control" name="newTemplateCopyBatchId" id="newTemplateCopyBatchId" v-model="newTemplateCopyBatchId" )
              option( v-bind:value="null" ) No thanks, make a new template
              option( v-for="t in templateBatches" v-bind:value="t.id" ) {{ t.name }} {{ t.description }}

          p( v-if="newTemplateCopyBatchId" class="pl-1" )
            label
              input( class="mr-2" type="checkbox" v-model="newTemplateDeleteOld" )
              span( class="text-danger" ) Also delete this old template after the new one is created

          p( v-else )
            label( for="newTemplateName" ) Enter a new name:
            input( class="form-control" type="text" name="newTemplateName" id="newTemplateName" v-model="newTemplateName" )

          div( class="custom-file" )
            input( id="csv" class="custom-file-input" type="file" v-on:change="updateCsvFile($event)" )
            label( for="csv" class="custom-file-label" ) {{ newTemplateCsv === null ? 'Choose file...' : newTemplateCsv.name }}

          div( class="mt-3 row" )
            div( class="col-6" )
              p( class="text-danger" v-if="newTemplateUploadError" ) {{ newTemplateUploadError }}
            div( class="col-6 text-right" )
              button( id="uploadBtn" class="btn btn-primary" v-bind:disabled="newTemplateCsv === null || isUploading" v-on:click="uploadNewTemplate" )
                MLoadingSpinner( class="mr-2" v-if="isUploading" )
                | Create Schedule Template

      hr

      h3( class="mt-4" ) Your Schedule Templates

      p( class="p-2 info-bg rounded mt-3 info-box" )
        i(class="fa fa-info-circle")
        |  Schedule Templates are used to create a new batch according to the timing specified by the scheduling profile.&nbsp;
        | Additionally, you can choose to start a batch running created from any Schedule Template by selecting 'Run now'.

      div( class="text-right" )
        p Page {{ templateBatchPage }} of {{ numPages }}
      
      div( class="row mb-4" )
        
        div( class="col-6" )
          input( class="form-control" placeholder="Filter batches by name" v-model="searchString" )

        div( class="col-6 text-right" )
          div( class="btn-group" )
            button(
              class="btn btn-primary"
              v-on:click="templateBatchPage -= 1"
              v-bind:disabled="templateBatchPage === 1"
            ) Previous Page

            button(
              class="btn btn-primary"
              v-on:click="templateBatchPage += 1"
              v-bind:disabled="templateBatchPage === numPages"
            ) Next Page
          
      div( class="ibox" v-if="showCreateNew" )
        div( class="ibox-content" )
          MBatchBuilder(
            v-on:save="onNewBatchSave"
            v-bind:queue-counts="queueCounts"
          )

      div( v-if="$apollo.queries.templateBatchesPaginated.loading" ) Loading...
      div( v-else-if="templateBatches.length === 0" ) No batches match the filter
      div( v-else )
        div( class="ibox" v-for="batch in templateBatches" v-bind:key="batch.id" )
          div( class="ibox-content p-0" )
            MBatchBuilder(
              v-bind:preloaded-batch="batch"
              v-on:delete="onBatchDelete"
              v-bind:queue-counts="queueCounts"
            )

</template>

<script>
import Vue from 'vue'
import gql from 'graphql-tag'
import dateFormat from 'dateformat'

export default Vue.extend({

  data() {
    return {
      recentBatchId: null,
      showCreateNew: false,
      creatingScheduledBatch: false,
      searchString: '',
      newTemplateName: '',
      newTemplateCsv: null,
      newTemplateUploadError: null,
      newTemplateCopyBatchId: null,
      newTemplateDeleteOld: false,
      isUploading: false,
      templateBatchPage: 1,
      templateBatchLimit: 100,
    }
  },

  apollo: {

    lastTenBatches: {
      query: gql`query LastTenBatches {
        batchMany(
          page: 1
          perPage: 100
          sort: {
           startedAt: DESC
          }
        ) {
          items {
            id
            name
            description
            startedAt
          }
        }
      }`,
      update: data => data.batchMany.items
    },

    templateBatchesPaginated: {
      query: gql`query TemplateBatches($page: Float!, $perPage: Float!, $search: String) {
        batchMany(
          page: $page
          perPage: $perPage
          sort: {
            startedAt: DESC
          }
          filter: {
            isTemplate: true
          }
          batchFilterString: $search
        ) {
          count
          items {
            id
            name
            description
            batchLinks {
              id
              batchId
              link
              order
              userDefinedNetwork
              userDefinedMerchant
              placement
              name
              tagA
              tagB
              tagC
              tagD
              tagE
              countryCode
              proxyYN
              proxyCountryCode
              cookieType
              cookieName
              cookieValue
              extraTimeout
            }
            startedAt
            csv
            isTemplate
            queueLetter
            owner {
              email
              name
              company {
                name
              }
            }
            scheduleType
            scheduleDay
            scheduleTime
            scheduleCron
            nextScheduledRunAt
            lastRunBatch {
              id
              startedAt
            }
            scheduledRunningPaused
            schedulingError
            useForLinkAssurance
            notifyOnComplete
          }
        }
      }`,

      update(data) {
        return data.batchMany
      },
      
      variables() {
        return {
          page: this.templateBatchPage,
          perPage: this.templateBatchLimit,
          search: this.searchString,
        }
      },

      debounce: 500,
    },

    queueCounts: {
      query: gql`query {
        queueCounts {
          name
          count
        }
      }`,
      variables() {
        return {
          companyId: this.$moonpull.getCurrentUserSession().company.id,
        }
      },
    },

  },

  watch: {
    searchString() {
      this.templateBatchPage = 1
    },
  },

  computed: {

    templateBatches() {
      return this.templateBatchesPaginated?.items || []
    },

    numPages() {
      if (! this.templateBatchesPaginated) return 1
      return Math.ceil(this.templateBatchesPaginated.count / this.templateBatchLimit)
    },

  },

  methods: {
    dateFormat,

    toggleShowCreateNew() {
      this.showCreateNew = ! this.showCreateNew
    },

    async onNewBatchSave() {
      await this.$apollo.queries.templateBatchesPaginated.refetch()
      this.showCreateNew = false
    },

    async onCreateScheduledBatch() {
      this.creatingScheduledBatch = true
      analytics.track("Scheduled Batch", {})
      await this.$apollo.mutate({
        mutation: gql`mutation CreateBatchFromRecent($batchId: ID!) {
          createTemplateBatchFromRecent(
            batchId: $batchId
          )
        }`,
        variables: {
          batchId: this.recentBatchId,
        },
      })
      await this.$apollo.queries.templateBatchesPaginated.refetch()
      this.creatingScheduledBatch = false
    },

    async onBatchDelete() {
      await this.$apollo.queries.templateBatchesPaginated.refetch()
    },

    updateCsvFile(e) {
      const file = e.target.files[0]

      if (! file.name.endsWith('.csv')) {
        this.fileUploadError = 'Only .CSV files are supported'
        return
      }

      this.newTemplateUploadError = ''
      this.newTemplateCsv = file
    },

    async uploadNewTemplate() {

      if (! this.newTemplateName && ! this.newTemplateCopyBatchId) {
        this.newTemplateUploadError = '"Name" is required'
        return
      }
      if (! this.newTemplateCsv) {
        this.newTemplateUploadError = 'You must choose a .CSV file'
        return
      }

      this.isUploading = true

      const batchMeta = {
        name: this.newTemplateName,
        isTemplate: true,
      }
      if (this.newTemplateCopyBatchId) {
        batchMeta.copyTemplateBatchId = this.newTemplateCopyBatchId
        batchMeta.name = this.templateBatches.find(t => t.id === this.newTemplateCopyBatchId).name
      }

      const isSuccess = await this.$moonpull.auditFromCsv(this.newTemplateCsv, batchMeta)
      if (isSuccess) {

        // Delete the old template if that option was selected
        if (this.newTemplateDeleteOld && this.newTemplateCopyBatchId) {
          await this.$apollo.mutate({
            mutation: gql`
              mutation ($id: ID!) {
                batchSoftDeleteById(id: $id) {
                  id
                }
              }
            `,
            variables: {
              id: this.newTemplateCopyBatchId
            }
          })
        }

        this.$store.dispatch('flashMessage', { type: 'success', msg: `Successfully created Scheduled Template from CSV${(this.newTemplateDeleteOld) ? ' and deleted the old Template Batch.' : ''}` })
        this.$apollo.queries.templateBatchesPaginated.refetch()
        this.newTemplateUploadError = null
        this.newTemplateCsv = null
        this.newTemplateName = null
        this.newTemplateCopyBatchId = null
        this.newTemplateDeleteOld = false
      }
      // Otherwise error
      else {
        this.newTemplateUploadError = 'There was an issue with the uploaded CSV'
      }
      
      this.isUploading = false
    },

  },
  beforeCreate(){
    analytics.page(
      " view", {
      "path": window.location.hash,
      "referrer": window.location.hash,
    })
  }
})
</script>